import { humanReadableFundingType } from '@aibees/elephant/feature/search-filters/config/funding-types';
import { DateTime, Icon } from '@aibees/shared/components';
import { HighlightableContent } from '@aibees/shared/features';
import { classnames, fHumanReadableCurrency } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { FinanceInfoCardProps as Props } from './types';

export const FinanceInfoCard = memo(
  ({ className, icon, title, value, date, type }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('FinanceInfoCard', className)}
        sx={SX.root}
      >
        <Stack direction="row" spacing={0.5} alignItems="flex-start">
          <Stack>
            <Icon name={icon} color="grey.500" size={20} />
          </Stack>

          <Stack direction="column" spacing={0.5} width="100%">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <HighlightableContent
                content={title}
                variant="body3"
                fontWeight={400}
                color="grey.700"
              />

              <HighlightableContent
                content={
                  value ? `${fHumanReadableCurrency(value)}` : 'Undisclosed'
                }
                variant="body4"
                fontWeight="bold"
                color="grey.700"
              />
            </Stack>
            {(type || date) && (
              <Stack direction="row" alignItems="center">
                {type && (
                  <Typography
                    color="grey.500"
                    fontWeight="light"
                    variant="body5"
                  >
                    {humanReadableFundingType(type)} •
                  </Typography>
                )}
                {date && (
                  <DateTime
                    value={date}
                    tooltipFormat="MMM yyyy"
                    color="grey.500"
                    fontWeight="light"
                    variant="body5"
                  />
                )}
              </Stack>
            )}
          </Stack>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

FinanceInfoCard.displayName = 'FinanceInfoCard';
